import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/tokens.css";
import "./assets/styles/global.css";
import errorHandler from "./plugins/errorHandler";

const app = createApp(App);
app.use(router);
app.use(errorHandler);
app.mount("#app");
